export default __webpack_public_path__ + "static/140-2d6ed4a4a424cf2009dd5c91a078d2a3.jpg";